import { AuthActions } from "../actions";

const initialState = {
  authenticated: null,
  me: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AuthActions.ACTION_AUTH_LOGIN:
      return {
        ...state,
        authenticated: action.payload,
      };
    case AuthActions.ACTION_AUTH_ME:
      state = {
        ...state,
        me: action.payload,
      };
      return state;
    case AuthActions.ACTION_AUTH_LOGOUT:
      return {};
    default:
      return state;
  }
};

export function isAuthenticated(state) {
  return state.auth.authenticated;
}

export function getMe(state) {
  return state.auth.me;
}

export function getProfileType(state) {
  return state.auth.me?.profileType;
}

export function getManagerContract(state) {
  return state.auth.me?.managerContract;
}
